import { PermissionType } from "@shared/api"
import { retryDynamicImport } from "@shared/lib"
import { RouteGuard } from "@shared/ui/route-guard"
import { Outlet, RouteObject } from "react-router-dom"

import { MrvLocaleLayout } from "../lib/i18n"

export default [
	{
		// MRV is English-only: force en-US for the whole MRV subtree so shared
		// (default-namespace) strings don't follow the user's app language.
		element: <MrvLocaleLayout />,
		children: [
			{
				path: "/carbon-savings/product-allocation",
				element: (
					<RouteGuard
						requiredPermissions={[
							PermissionType.MrvAnnualAssurer,
							PermissionType.MrvCoordinator,
							PermissionType.Admin,
						]}
					>
						<Outlet />
					</RouteGuard>
				),
				children: [
					{
						index: true,
						lazy: () =>
							retryDynamicImport(
								() => import("../product-allocation"),
							).then(m => ({
								Component: m.ProductAllocationPage,
							})),
					},
					{
						path: ":id",
						lazy: () =>
							retryDynamicImport(
								() => import("../product-allocation-details"),
							).then(m => ({
								Component: m.ProductAllocationDetailsPage,
							})),
					},
				],
			},
			{
				path: "/carbon-savings/assure-reductions",
				element: (
					<RouteGuard
						requiredPermissions={[
							PermissionType.MrvCoordinator,
							PermissionType.MrvDepositAssurer,
						]}
					>
						<Outlet />
					</RouteGuard>
				),
				children: [
					{
						index: true,
						lazy: () =>
							retryDynamicImport(
								() => import("../carbon-reductions"),
							).then(m => ({
								Component: m.CarbonReductionsPage,
							})),
					},
					{
						path: ":plantNumber/:id",
						lazy: () =>
							retryDynamicImport(
								() => import("../carbon-reductions-details"),
							).then(m => ({
								Component: m.CarbonReductionsDetailsPage,
							})),
					},
				],
			},
			{
				path: "/carbon-savings/plants",
				element: (
					<RouteGuard
						requiredPermissions={[
							PermissionType.MrvAnnualAssurer,
							PermissionType.MrvCoordinator,
							PermissionType.Admin,
						]}
					>
						<Outlet />
					</RouteGuard>
				),
				children: [
					{
						index: true,
						lazy: () =>
							import("../plant-overview").then(m => ({
								Component: m.PlantOverviewPage,
							})),
					},
					{
						path: ":id",
						lazy: () =>
							import("../plant-details").then(m => ({
								Component: m.PlantDetailsPage,
							})),
					},
				],
			},
		],
	},
] satisfies RouteObject[]
